import dashBoard from './components/Examiner/ExaminerDashboard.vue';
import viewProducts from './components/Examiner/products/products.vue';
import productPage from './components/Examiner/products/productPage.vue';
import ViewAircraft from './components/Examiner/products/ViewAircraft.vue';
import ViewSpecifics from './components/Examiner/products/ViewSpecifics.vue';
import ViewChapters from './components/Examiner/products/ViewChapters.vue';
import ViewAssessmentTasks from './components/Examiner/products/ViewAssessmentTasks.vue';
import importTasksPage from './components/Examiner/products/ImportTasks/ImportTasks.vue';
import IssuesDisplay from './components/Examiner/products/ImportTasks/issuesDisplay.vue';
import ImportAssessmentTasks from './components/Examiner/products/ImportTasks/ImportAssessmentTasks.vue';
import AssessmentIssuesDisplay from './components/Examiner/products/ImportTasks/AssessmentIssuesDisplay.vue';
import importSuccessful from './components/Examiner/products/ImportTasks/importSuccessful.vue';
import importAssessmentSuccessful from './components/Examiner/products/ImportTasks/importAssessmentSuccessful.vue';

import { createRouter, createWebHistory } from 'vue-router';

import Login from './components/Examiner/userLogin.vue';
import ResetPasswordPage from './components/Examiner/ResetPasswordPage.vue';
import TemporaryLogin from './components/Examiner/TemporaryLogin.vue';
import ViewUsers from './components/Examiner/ViewUsers.vue';
import ViewUsersTrainees from './components/Examiner/ViewUsersTrainees.vue';
import ViewRevisions from './components/Examiner/ViewRevisions.vue';
import TimeOut from './components/Examiner/TimeOut.vue';

import ExaminerHelp from './components/Examiner/ExaminerHelp.vue';

import InstructorHome from './components/Instructor/InstructorHome.vue';
import InstructorLogbook from './components/Instructor/InstructorLogbook.vue';
import MultiSignOff from './components/Instructor/MultiSignOff.vue';
import MultiEnable from './components/Instructor/MultiEnable.vue';

import TraineeHome from './components/Trainee/TraineeHome.vue';
import TraineeLogbook from './components/Trainee/TraineeLogbook.vue';

import ViewProjects from './components/Examiner/projects/ViewProjects.vue';

import ViewLogbooks from './components/Examiner/logbooks/ViewLogbooks.vue';
import AddLogbook from './components/Examiner/logbooks/AddLogbook.vue';

import ViewTraineeTable from './components/Examiner/trainees/ViewTraineeTable.vue';
import ImportTrainees from './components/Examiner/trainees/ImportTrainees.vue';
import TraineeIssuesDisplay from './components/Examiner/trainees/TraineeIssuesDisplay.vue';
import TraineeImportSuccessful from './components/Examiner/trainees/TraineeImportSuccessful.vue';

import ViewReports from './components/Examiner/reports/ViewReports.vue';
import TraineeReports from './components/Examiner/reports/TraineeReports.vue';
import TraineeReportsHTML from './components/Examiner/reports/TraineeReportsHTML.vue';

import devDev from './components/devDev.vue';
import attendanceLogin from './components/attendanceLogin.vue'

const routes = [
    {
        name: 'attendanceLogin',
        component: attendanceLogin,
        path: '/attendanceLogin',
    },
    {
        name: 'devDev',
        component: devDev,
        path: '/devDev',
    },
    {
        name: 'examinerDashboard',
        component: dashBoard,
        path: '/dashboard',
    },
    {
        name: 'ViewUsers',
        component: ViewUsers,
        path: '/view-users',
    },
    {
        name: 'ViewUsersTrainees',
        component: ViewUsersTrainees,
        path: '/view-users-trainees',
    },
    {
        name: 'ViewAircraft',
        component: ViewAircraft,
        path: '/view-aircraft',
    },
    {
        name: 'ViewSpecifics',
        component: ViewSpecifics,
        path: '/view-specifics',
    },
    {
        name: 'ViewChapters',
        component: ViewChapters,
        path: '/view-chapters',
    },
    {
        name: 'ViewAssessmentTasks',
        component: ViewAssessmentTasks,
        path: '/view-assessment-tasks',
    },
    {
        name: 'products',
        component: viewProducts,
        path: '/products',
    },
    {
        path: '/products/:productId',
        name: 'productPage',
        component: productPage
    },
    {
        path: '/products/:productId/import-csv',
        name: 'importTasks',
        component: importTasksPage
    },
    {
        path: '/import-assessment-csv',
        name: 'ImportAssessmentTasks',
        component: ImportAssessmentTasks
    },
    {
        path: '/products/:productId/import-csv/issues',
        name: 'IssuesDisplay',
        component: IssuesDisplay
    },
    {
        path: '/import-csv/assessment-issues',
        name: 'AssessmentIssuesDisplay',
        component: AssessmentIssuesDisplay
    },
    {
        path: '/products/:productId/import-csv/import-successful',
        name: 'importSuccessful',
        component: importSuccessful
    },
    {
        path: '/import-csv/import-successful',
        name: 'importAssessmentSuccessful',
        component: importAssessmentSuccessful
    },
    {
        name: 'LoginPage',
        component: Login,
        path: '/',
    },
    {
        name: 'ResetPasswordPage',
        component: ResetPasswordPage,
        path: '/reset-password',
    },
    {
        name: 'TemporaryLogin',
        component: TemporaryLogin,
        path: '/temp-login',
    },
    {
        name: 'ViewRevisions',
        component: ViewRevisions,
        path: '/view-revisions',
    },
    {
        name: 'ViewProductRevisions',
        component: () => import('./components/Examiner/ViewProductRevisions.vue'),
        path: '/view-product-revisions/:productId',
    },
    {
        name: 'InstructorHome',
        component: InstructorHome,
        path: '/instructor-home',
    },
    {
        name: 'InstructorLogbook',
        component: InstructorLogbook,
        path: '/instructor-logbook/:traineeId',
    },
    {
        name: 'MultiSignOff',
        component: MultiSignOff,
        path: '/multi-so/:projectId',
    },
    {
        name: 'MultiEnable',
        component: MultiEnable,
        path: '/multi-enable/:projectId',
    },
    {
        name: 'TraineeHome',
        component: TraineeHome,
        path: '/trainee-home',
    },
    {
        name: 'TraineeLogbook',
        component: TraineeLogbook,
        path: '/trainee-logbook/:logbookId',
    },
    {
        name: 'ViewProjects',
        component: ViewProjects,
        path: '/projects',
    },
    {
        name: 'AddLogbook',
        component: AddLogbook,
        path: '/add-logbook',
    },
    {
        name: 'ViewLogbooks',
        component: ViewLogbooks,
        path: '/logbooks',
    },
    {
        name: 'ViewTraineeTable',
        component: ViewTraineeTable,
        path: '/trainees',
    },
    {
        name: 'ImportTrainees',
        component: ImportTrainees,
        path: '/import-trainees',
    },
    {
        path: '/import-trainees/issues',
        name: 'TraineeIssuesDisplay',
        component: TraineeIssuesDisplay
    },
    {
        path: '/import-trainees/import-successful',
        name: 'TraineeImportSuccessful',
        component: TraineeImportSuccessful,
    },
    {
        name: 'ViewReports',
        component: ViewReports,
        path: '/reports',
    },
    {
        name: 'TraineeReports',
        component: TraineeReports,
        path: '/trainee-reports',
    },
    {
        name:'TraineeReportsHTML',
        component:TraineeReportsHTML,
        path:'/trainee-reports-html/:trainee_id',
    },
    {
        name:'TimeOut',
        component:TimeOut,
        path:'/timeout',
    },
    {
        name: 'ExaminerHelp',
        component: ExaminerHelp,
        path: '/help',
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    mode: "history",
    base: '/'
});

export default router;